import type { ProductTaggingSearchResult } from '../type';

/**
 * Whether the search-result tile should use neutral grey (#f2f1f0) + multiply on the thumb.
 * Matches `FollowSelectorItem` in the moodboards picker:
 * - Professionals: multiply when no logo background.
 * - Products: multiply when `isMultiplied`, `isClearCut`, or no `logoBackground`.
 */
export function getUsesNeutralMultiplyTreatment(
    tile: Pick<
        ProductTaggingSearchResult,
        'pType' | 'logoBackground' | 'isMultiplied' | 'isClearCut'
    >,
): boolean {
    if (tile.pType === 'OffPlatformSupplier') {
        return false;
    }
    if (tile.pType === 'Professional') {
        return !tile.logoBackground;
    }
    return !!tile.isMultiplied || !!tile.isClearCut || !tile.logoBackground;
}
